import { Modal } from "react-bootstrap";
import { description, i_have_permission } from '../../../resources/string/strings'
import ExtraInfo from "../../util/extra-info";
import { ReactComponent as IconCLose } from "../../../resources/image/ic_cross_gray.svg";
import Links from "../../util/links";

export default function VerticalModal(props) {
  return (
    <Modal
      {...props}
      size="lg"
      className="modal"
      dir="rtl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >

      <Modal.Body className="text-center mr-0 ml-auto">

        <IconCLose
          style={{ float: "left", color: "GrayText" }}
          className="p-0 clickable"
          width="16"
          height="16"
          fill="gray"
          color="gray"
          onClick={props.onHide}
        />

        {props.item !== undefined &&
          <div>
            {props.item.pictureUrl !== undefined && props.item.pictureUrl !== null && props.item.pictureUrl.length > 0 &&
              <img
                style={{ marginRight: 16 }}
                height="35"
                src={props.item.pictureUrl}
                alt=""
              />

            }

            <div className="mt-2 mb-2" style={{ fontSize: 20 }}>{props.item.title}</div>

            {props.item.description !== undefined && props.item.description !== null && props.item.description !== "" &&
              <div style={{
                textAlign: "right"
              }}>
                <hr style={{ color: "gray" }} />
                <ExtraInfo
                  extraInfo={props.item.description}
                  title={description}
                />
              </div>
            }

            {!props.accessallowed && props.item.permissionRequired &&
              <div>

                <hr style={{ color: "gray" }} />

                <div className="mb-3 mt-3" style={{ fontSize: 11, color: "GrayText", textAlign: "right" }}>
                  برای مشاهده لینک
                  باید دسترسی لازم در سرویس مورد نظر را داشته باشید. این دسترسی ها باید خارج از این کنسول به اکانت شما داده شود. برای درخواست دسترسی با مسئول مربوطه در ارتباط باشید.
                </div>

                <button button className="btn btn-success"
                  onClick={() => {
                    if (props.item.links !== undefined && props.item.links !== null && props.item.links.length === 1) {
                      props.onlinkopen(props.item.links[0].link)
                    } else {
                      props.allowaccess()
                    }
                  }}>{i_have_permission}</button>

              </div>
            }

            {props.accessallowed && props.item.links !== undefined && props.item.links !== null && props.item.links.length > 0 &&
              <div>
                <hr style={{ color: "gray" }} />
                <Links
                  links={props.item.links}
                />
              </div>
            }

          </div>
        }

      </Modal.Body>

    </Modal>
  );
}